package com.schoolconnect.app.feature.common

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.ContentTransform
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.scaleIn
import androidx.compose.animation.scaleOut
import androidx.compose.animation.slideInHorizontally
import androidx.compose.animation.slideOutHorizontally
import androidx.compose.animation.core.FastOutSlowInEasing
import androidx.compose.animation.core.tween
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

/**
 * Shared motion language for changing screens within the app.
 *
 * The very small directional slide establishes continuity, while the restrained
 * fade/scale keeps dense admin screens feeling calm instead of theatrical.
 */
@Composable
fun <T> AppScreenTransition(
    targetState: T,
    modifier: Modifier = Modifier,
    content: @Composable (T) -> Unit
) {
    AnimatedContent(
        targetState = targetState,
        modifier = modifier,
        contentKey = { it },
        transitionSpec = {
            ContentTransform(
                targetContentEnter = fadeIn(
                    animationSpec = tween(180, easing = FastOutSlowInEasing)
                ) + slideInHorizontally(
                    initialOffsetX = { fullWidth -> fullWidth / 30 },
                    animationSpec = tween(200, easing = FastOutSlowInEasing)
                ) + scaleIn(
                    initialScale = 0.995f,
                    animationSpec = tween(200, easing = FastOutSlowInEasing)
                ),
                initialContentExit = fadeOut(
                    animationSpec = tween(100, easing = FastOutSlowInEasing)
                ) + slideOutHorizontally(
                    targetOffsetX = { fullWidth -> -fullWidth / 48 },
                    animationSpec = tween(140, easing = FastOutSlowInEasing)
                ) + scaleOut(
                    targetScale = 0.995f,
                    animationSpec = tween(140, easing = FastOutSlowInEasing)
                ),
                sizeTransform = null
            )
        },
        label = "app_screen_transition"
    ) { state ->
        content(state)
    }
}
